import { showFormAlert } from '../view/showFormAlert.js';
import { LINK_APPLE } from './OTP/LINK_APPLE.constant.js';
import { LINK_GOOGLE } from './OTP/LINK_GOOGLE.constant.js';

/* EXAMPLE stepData
  {
    "qr": "iVBORw0KGgoAAAANSUhEUgAAAMgAAADIAQAAAACFI5MzAAABqklEQVR42u2YzYrDMAyEDXotgV5d4NcSeGfGZZMN7M2CHmLagPMdLMmjn3as/9Z4yUu+huQYNle5zZmBL7YtZOIzy1aCVWjbQ9J4dI7IYRXc9hHDY3vaSsoYSR8ejUSQIaUR8xHrc0QKudZTO8eIVkbSTx3+NxeOEbw0aFGaL4/yy7ajhO9GIJ4VCRNmwpAO8jkfsAaWu60WgrtyKBCOygBppIUUZe6GaCK1kMVpTcTh3VREfedxD+F+6xwFI1gEW8iq4NmBe0NQLb2JfKqr3KUl47cinSW4OD5HMLJxV8hZQg0qvYySj51YDQTCY+NDRdp5zHTuINIIuwUiCktYz1tI6t0U37kVLQRhNLqJHGZFUn1tISZfoXjWJbJoIVLIouKpDorfWsiOaLEtKaTjEetThHMDil2xY7Ai3XrwWUKVa0wtTnacJ1vIHuegD1K/39xZImeZUhQIkitjtRA2CwqQPdA0tfYQTfgQosZuZvJsIqpBTK2teGskS7M3Ioq0qmuyO06K3UK5JS32kM+PFoqQN7euCeUooUJQLdifaAJj2kLe/wJe8s3kB6KVQoNhdvjOAAAAAElFTkSuQmCC",
    "seed": "QSOYHUVWPHRFFTBT"
  }
*/
export default {
  events: {
    visible: (eWizard, stepData) => {
      // Control para bloquear form
      const img = eWizard.querySelector('#imgQR');
      if (stepData?.qr && img) {
        img.src = `data:image/PNG;base64,${stepData.qr}`;
        eWizard.querySelector('#otpConfirm')?.removeAttribute('disabled');
      } else {
        // No podemos continuar
        eWizard.eBtnNext?.setAttribute('disabled', '');
        eWizard.eBtnFinish?.setAttribute('disabled', '');
      }
    },
    step: (eWizard, stepData, resolve, reject) => {
      const checkMandatory = eWizard.querySelector('#otpConfirm')?.value;
      if (checkMandatory) {
        stepData.confirm = 1;
        resolve(stepData); // OK
      } else {
        showFormAlert();
        reject(); // KO
      }
    },
  },
  template: `
  <template label="${edicom.locale.translate('enrollment.otp.title')}">
    <ewc-layout>
      <div slot="main">
        <ewc-alert type="flat" label="${edicom.locale.translate('enrollment.otp.title')}">
          <div style="white-space:normal;">
            ${edicom.locale.translate('enrollment.otp.intro')}<br/>
            ${edicom.locale.translate('enrollment.otp.intro2')}<br/>
            ${edicom.locale.translate('enrollment.otp.intro3')}<br/>
            ${edicom.locale.translate('enrollment.otp.intro3.1')}
            <br/><br/>
            <div style="text-align:center;">
              ${LINK_GOOGLE}
              ${LINK_APPLE}
            </div>
          </div>
        </ewc-alert>
        <br/>
        <div style="text-align:center;">
          ${edicom.locale.translate('enrollment.otp.intro4')}<br/>
          <img id="imgQR" src="data:image/PNG;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=" alt="QR"></img>
        </div>
        <ewc-checkbox id="otpConfirm" required disabled label="${edicom.locale.translate('enrollment.otp.label.confirm')}"></ewc-checkbox>
      </div>
    </ewc-layout>
  </template>`,
};
